import router from '@/router';
import { isRef, isReactive } from 'vue';
import { cloneDeep } from 'lodash';
import { useLayoutStore } from '@/store/modules/layout';

export const pushAndSaveQueries = (path = '/', queries = {}, searchDate = null, searchBirthDate=null) => {
  const layoutStore = useLayoutStore();
  let query;
  if (isRef(queries)) query = cloneDeep(queries.value);
  if (isReactive(queries)) query = cloneDeep(queries);

  query.currentPath = location.pathname;
  // searchDate가 ref인 경우 .value 사용
  query.searchDate = isRef(searchDate) ? searchDate.value : searchDate;
  query.searchBirthDate = isRef(searchBirthDate) ? searchBirthDate.value : searchBirthDate;

  layoutStore.query = query;
  router.push(path);
};

export const recoverFromQueries = (params = {}, searchDate = null, searchBirthDate=null) => {
  const layoutStore = useLayoutStore();
  const queries = cloneDeep(layoutStore.query);

  if (queries.currentPath === location.pathname) {
    Object.keys(queries).forEach((key) => {
      if (key === 'searchDate' || key === 'currentPath') return;

      if (isRef(params)) params.value[key] = queries[key];
      if (isReactive(params)) params[key] = queries[key];
    });

    // searchDate 복구
    if (searchDate) {
      if (isRef(searchDate)) {
        searchDate.value = queries.searchDate || '';
      }
    }
    if (searchBirthDate) {
      if (isRef(searchBirthDate)) {
        searchBirthDate.value = queries.searchBirthDate || '';
      }
    }
  }

  layoutStore.query = {};
};